import { Box, Container, FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { PaperTableHeader } from "../../_components/table/header.table";
import { PaperHeaderButton } from "../../_components/button/paperHeader.button";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IFilteringViewModel } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { RacingLicenseTypeManageDrawer } from "./racingLicenseType-manage";
import { IRacingLicenseTypeListData } from "../../_common/interface/racingLicenseType/iRacingLicenseTypeListData";
import { racingLicenseTypeService } from "../../_services/racingLicenseType.service";
import { toastr } from "../../_components/toastr/toastr";
import { TableHeaderMs } from "../../_components/table/header.ms.table";
import { HeaderMsButton } from "../../_components/button/header.ms.button";
import { useContainerStyles } from "../../_styles/container.styles";
import { PageHeader } from "../../_components/header/page.header";
import StyledGrid from "../../_components/grid/styledGrid";


export function RacingLicenseTypeIndex() {

    const [data, setData] = useState<IRacingLicenseTypeListData>({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return racingLicenseTypeService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }
    function onDelete(id: number) {
        setLoading(true);
        return racingLicenseTypeService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success(" Motorsport Licence Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }
    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };


    return (

        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Motorsport Licence Types"
                    buttonName="Motorsport Licence Type"
                    onClick={() => setSelectedId(0)}
                    actionType="create"
                />

                <Paper>

                    <ValidatorForm onSubmit={fetchData}>

                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>

                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        onEdit={setSelectedId}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />

                    <RacingLicenseTypeManageDrawer
                        isOpen={selectedId != null}
                        itemId={selectedId}
                        onSave={() => { setSelectedId(null); fetchData(); }}
                        onClose={() => { setSelectedId(null); fetchData(); }}
                    />

                </Paper>

            </div>
        </>


    );

}
